module.exports = __webpack_public_path__ + "img/output-2.a92fa56d.png";